import { BaseError } from '~/lib/error/base';

export class ForgotPasswordFailedError extends BaseError {
  constructor(message: string) {
    super({ code: 'FORGOT_PASSWORD_FAILED', message });
  }
}
